import { CMA_DELIVERY_ENABLED, CMA_DELIVERY_ENDPOINT } from '../config/messaging';
import { NOTIFICATIONS_ENABLED } from '../config/notifications';

// Sends a CMA PDF to one client by text or email. Nothing leaves until both switches are on
// and the server function at CMA_DELIVERY_ENDPOINT is connected to your text and email service.
export const cmaDeliveryReady = () => NOTIFICATIONS_ENABLED && CMA_DELIVERY_ENABLED;

const blobToBase64 = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(String(reader.result).split(',')[1]);
  reader.onerror = reject;
  reader.readAsDataURL(blob);
});

// Returns the reason a CMA was not sent, so the screen can show the right message.
export const sendCmaToClient = async ({ channel, to, body, file, fileName }) => {
  if (!NOTIFICATIONS_ENABLED) return { sent: false, reason: 'sending_disabled' };
  if (!CMA_DELIVERY_ENABLED) return { sent: false, reason: 'service_not_connected' };
  if (!to) return { sent: false, reason: 'no_recipient' };
  try {
    const pdfBase64 = await blobToBase64(file);
    const res = await fetch(CMA_DELIVERY_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ channel, to, body, fileName, pdfBase64 }),
    });
    return res.ok ? { sent: true } : { sent: false, reason: 'send_failed' };
  } catch (err) {
    console.error('CMA send failed:', err);
    return { sent: false, reason: 'send_failed' };
  }
};
